import React from 'react';
import { Link } from 'react-router-dom';
import ManualViewer from '../../components/Manual/ManualViewer';

export default function ManualIndex() {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="border-b border-gray-200 bg-white px-4 py-2 flex items-center gap-3 text-sm">
        <Link to="/dashboard" className="text-teal-700 font-medium hover:underline">
          ← Volver al sistema
        </Link>
        <span className="text-gray-400">|</span>
        <span className="text-gray-600">Manual de usuario</span>
      </div>
      <ManualViewer />
    </div>
  );
}
